import $ from "jquery/dist/jquery";

import nouislider from "nouislider/dist/nouislider.js";
import "nouislider/dist/nouislider.css";

$.fn.facetSlider = function (options = {}) {
  var opts = $.extend({}, options);

  function niceprice(x) {
    parseFloat(x).toLocaleString("cs");
  }

  $(this).each(function () {
    let thisslider = $(this);

    let min = $(".facetfilter #" + $(this).attr("data-input-min"));
    let max = $(".facetfilter #" + $(this).attr("data-input-max"));
    let doformat = $(this).attr("data-doformat");

    let min_shown = null;
    let max_shown = null;

    if ($(this).attr("data-input-min-shown")) {
      min_shown = $(".facetfilter #" + $(this).attr("data-input-min-shown"));
    }
    if ($(this).attr("data-input-max-shown")) {
      max_shown = $(".facetfilter #" + $(this).attr("data-input-max-shown"));
    }
    let shown_append = $(this).attr("data-input-shown-append");

    let uis = nouislider.create(this, {
      start: [min.val(), max.val()],
      connect: true,
      range: {
        min: parseInt($(this).attr("data-value-min")),
        max: parseInt($(this).attr("data-value-max")),
      },
    });
    uis.on("update", (values, handle) => {
      let minv = Math.round(values[0]);
      let maxv = Math.round(values[1]);
      min.val(minv);
      max.val(maxv);

      if (min_shown) {
        if (doformat == "niceprice") {
          min_shown.html(niceprice(minv) + shown_append);
        } else {
          min_shown.html(minv.toString() + shown_append);
        }
      }
      if (max_shown) {
        if (doformat == "niceprice") {
          max_shown.html(niceprice(maxv) + shown_append);
        } else {
          max_shown.html(maxv.toString() + shown_append);
        }
      }
    });
    uis.on("change", (e) => {
      thisslider.trigger("slide-change");
    });

    min.on("change", (e) => {
      uis.set([$(e.target).val()]);
    });
    max.on("change", (e) => {
      uis.set([null, $(e.target).val()]);
    });
  });
};

$(() => {
  $(".facetfilter .facet-slider").facetSlider();
});
